import { FC, useMemo } from "react";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  BookingStatusEnum,
  DATA_E2E_KEY,
  IStyledAttributes,
  NO_VALUE_DISPLAY,
  useIsMobile,
} from "@ryde/shared";

import {
  IStatusIndicatorBooking,
  IStatusIndicatorBookingControl,
  StatusIndicatorBookingConst,
} from "./status.indicator.booking.models";

export const StatusIndicatorBookingStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "status-indicator-booking",
  },
)<IStatusIndicatorBookingControl>`
  margin-inline-start: auto;
  color: ${props => props.$leftColor};
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;

  div {
    background-color: ${props => props.$leftColor};
  }
`;

export const RoundDivBooking = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "round-div-booking",
})`
  width: 8px;
  height: 8px;
  border-radius: 4px;
`;

export const StatusIndicatorBooking: FC<IStatusIndicatorBooking> = ({
  status,
}) => {
  const info = StatusIndicatorBookingConst[status || BookingStatusEnum.New];
  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    if (!status || !info?.$translateKey) {
      return NO_VALUE_DISPLAY;
    }

    const text = translateLabel(info.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info?.$translateKey, isMobile, status, translateLabel]);

  return (
    <StatusIndicatorBookingStyled {...info}>
      <RoundDivBooking />
      {statusText}
    </StatusIndicatorBookingStyled>
  );
};
